import { render } from "./index.vue?vue&type=template&id=51145d4e"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"

import "./stylesheet/index.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__